module.exports = __webpack_public_path__ + "static/media/S (48).346f7662.jpg";